import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss'],
})
export class FaqsComponent implements AfterViewInit {
  @ViewChild('elementToFocus') elementToFocus!: ElementRef;
  constructor() {}
  ngAfterViewInit() {
    // Navigate to the top of the page
    window.scrollTo(0, 0);

    // Focus on the element
    this.elementToFocus.nativeElement.focus();
  }

  navigateToTop() {
    // Alternatively, you can navigate to the top when a button is clicked
    window.scrollTo(0, 0);
  }
}
